module.exports = __webpack_public_path__ + "img/3S.4f773797.png";